import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb, Typography } from "antd";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { customMarkVariants, letterVariants } from "./variants";
const PageHeader = ({ href = "" }) => {
  const title = href.substring(1).replace("-", " ");

  return (
    <header className="page-header">
      <div className="container page-header-inner">
        <div className="page-header-inner-left flex-shrink-0">
          <CustomBreadcrum title={title} href={href} />
          <Typography.Title className="m-0 text-capitilize">{title}</Typography.Title>
        </div>
        <div className="page-header-inner-right">
          <CustomMark />
        </div>
      </div>
    </header>
  );
};

export default PageHeader;

const CustomBreadcrum = ({ title, href }) => (
  <Breadcrumb
    itemRender={itemRender}
    items={[
      {
        href: "",
        title: <HomeOutlined />,
      },
      {
        href,
        title,
      },
    ]}
  />
);

const CustomMark = ({ markText = "HENNIE STANDER" }) => (
  <motion.div
    variants={customMarkVariants}
    className="hennie-mark"
    initial={"hidden"}
    whileInView={"visible"}
  >
    {markText.split("").map((letter, index) => (
      <motion.span
        className="font-chakra"
        variants={letterVariants}
        key={index}
      >
        {letter}
      </motion.span>
    ))}
  </motion.div>
);

const itemRender = (route) => (
  <NavLink
    className={({ isActive }) => `breadcrum-link ${isActive ? "active" : ""}`}
    to={route.href}
  >
    {route.title}
  </NavLink>
);
